module.exports = __webpack_public_path__ + "img/back.aba8e268.svg";